<script setup lang="ts">
const colorMode = useColorMode();
</script>

<template>
    <ColorScheme>
        <v-theme-provider with-background :theme="colorMode.preference">
            <v-app>
                <v-layout>
                    <app-nav />
                    <v-main>
                        <v-container fluid class="flex align-start">
                            <NuxtPage />
                        </v-container>
                    </v-main>
                </v-layout>
            </v-app>
        </v-theme-provider>
    </ColorScheme>
</template>
